const FETCH_STORY = 'storyDetail/FETCH_STORY';

const FETCH_STORY_EPISODES = 'storyDetail/FETCH_STORY_EPISODES';

const FOLLOW_USER = 'storyDetail/FOLLOW_USER';

const PURCHASE_EPISODE = 'storyDetail/PURCHASE_EPISODE';

const LIKE_STORY = 'storyDetail/LIKE_STORY';

const UPDATE_LATEST_READ = 'storyDetail/UPDATE_LATEST_READ';

const RESET_LATEST_READ = 'storyDetail/RESET_LATEST_READ';

const RESET = 'storyDetail/RESET';

const FETCH_VOTE_EVENT_STORY = 'storyDetail/FETCH_VOTE_EVENT_STORY';

const VOTE_STORY = 'storyDetail/VOTE_STORY';

const FETCH_STORY_CHEER = 'storyDetail/FETCH_STORY_CHEER';

const FETCH_STORY_CHEER_LIST = 'story/Detail/FETCH_STORY_LATEST_CHEER_LIST';

const FETCH_STORY_CHEER_RANKING_LIST =
  'storyDetail/FETCH_STORY_CHEER_RANKING_LIST';

const RESET_STORY_CHEER_RANKING_LIST =
  'storyDetail/RESET_STORY_CHEER_RANKING_LIST';

const RESET_STORY_CHEER_LIST = 'storyDetail/RESET_STORY_CHEER_LIST';

const RESET_STORY_CHEER = 'storyDetail/RESET_STORY_CHEER';

const DONATE_STORY = 'storyDetail/DONATE_STORY';

const CHEER_STORY = 'storyDetail/CHEER_STORY';

const PREVIEW_BY_BALLOON = 'common/PREVIEW_BY_BALLOON';

export default {
  FETCH_STORY,
  FETCH_STORY_EPISODES,
  PURCHASE_EPISODE,
  FOLLOW_USER,
  LIKE_STORY,
  UPDATE_LATEST_READ,
  RESET_LATEST_READ,
  RESET,
  FETCH_VOTE_EVENT_STORY,
  VOTE_STORY,
  FETCH_STORY_CHEER,
  FETCH_STORY_CHEER_LIST,
  FETCH_STORY_CHEER_RANKING_LIST,
  RESET_STORY_CHEER_RANKING_LIST,
  RESET_STORY_CHEER_LIST,
  RESET_STORY_CHEER,
  DONATE_STORY,
  CHEER_STORY,
  PREVIEW_BY_BALLOON,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/storyDetail/types.js